import { Component, OnInit, Input, ViewEncapsulation, OnDestroy } from '@angular/core';
import { LoadingController, SpinnerEvent } from './loader-controller.service';
import { Subscription } from 'rxjs';

@Component({
    /* tslint:disable-next-line */
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class LoaderComponent implements OnDestroy {

    @Input() spinner: string = 'default';
    @Input() text: string = 'Please wait...';
    @Input() backdropClass: string;
    @Input() textClass: string;

    private _timerRef: any;
    private _subscription: Subscription;

    isVisible = false;

    constructor(private _loadingService: LoadingController) {
        this._subscription = this._loadingService.spinnerObservor.subscribe((data: SpinnerEvent) => {
            if (data.shouldShow) {
                this.show(data.threshold);
            } else {
                this.hide();
            }
        });
    }

    show(thershold?: number) {
        if (thershold) {
            this._timerRef = setTimeout(() => {
                this.isVisible = true;
            }, thershold);
        } else {
            this.isVisible = true;
        }
    }

    hide() {
        // console.log('We Need to Hide Loader');
        if (this._timerRef) {
            clearInterval(this._timerRef);
        }
        this.isVisible = false;
    }

    ngOnDestroy() {
        this._subscription.unsubscribe();
    }

}
